import { useEffect, useState } from "react";
import { ToolInfoDto } from "../api/models/ToolInfoDto";
import { getToolCapabilities } from "../api/toolsClient";

export const useToolsCapabilities = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [tools, setTools] = useState<ToolInfoDto[]>([]);

  useEffect(() => {
    const fetchTools = async () => {
      setIsLoading(true);
      try {
        const data = await getToolCapabilities();
        setTools(data);
      } catch (error) {
        console.error("Failed to fetch tool capabilities", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTools();
  }, []);

  return {
    isLoading,
    tools,
  };
};
